// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/icomoon.eot?3qm5q8", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/icomoon.ttf?3qm5q8", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/icomoon.woff?3qm5q8", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/icomoon.svg?3qm5q8", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#icomoon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "icomoon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-],
[class*=" icon-"] {
  font-family: "icomoon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-Double-arrow:before {
  content: "\\e900";
}

.icon-mail-line-2:before {
  content: "\\e901";
}

.icon-Fb:before {
  content: "\\e902";
}

.icon-linkedin:before {
  content: "\\e903";
}

.icon-Pinterest:before {
  content: "\\e904";
}

.icon-Twitter:before {
  content: "\\e905";
}

.icon-youtube:before {
  content: "\\e906";
}

.icon-award-line:before {
  content: "\\e907";
}

.icon-artboard-line:before {
  content: "\\e908";
}

.icon-translate:before {
  content: "\\e909";
}

.icon-bar-chart-2-line:before {
  content: "\\e90a";
}

.icon-Note-text-line:before {
  content: "\\e90b";
}

.icon-file-text-line:before {
  content: "\\e90c";
}

.icon-user-2:before {
  content: "\\e90d";
}

.icon-draft-line:before {
  content: "\\e90e";
}

.icon-arrow-up-s-line:before {
  content: "\\e90f";
}

.icon-lock-password-line:before {
  content: "\\e910";
}

.icon-share-fill:before {
  content: "\\e911";
}

.icon-reply-all-fill:before {
  content: "\\e912";
}

.icon-calendar-check-line:before {
  content: "\\e913";
}

.icon-user-fill-solid:before {
  content: "\\e914";
}

.icon-award-fill-solid:before {
  content: "\\e915";
}

.icon-discuss-line:before {
  content: "\\e916";
}

.icon-user-2-line_tie:before {
  content: "\\e917";
}

.icon-pentool:before {
  content: "\\e918";
}

.icon-book-mark-fill-solid:before {
  content: "\\e919";
}

.icon-arrow-right-s-line-right:before {
  content: "\\e91a";
}

.icon-book-line:before {
  content: "\\e91b";
}

.icon-shopping-basket-2-line:before {
  content: "\\e91c";
}

.icon-trophy-line:before {
  content: "\\e91d";
}

.icon-checkbox-circle-fill-solid:before {
  content: "\\e91e";
}

.icon-checkbox-circle-fill:before {
  content: "\\e91f";
}

.icon-eye-line:before {
  content: "\\e920";
}

.icon-call:before {
  content: "\\e921";
}

.icon-user-fill:before {
  content: "\\e922";
}

.icon-award-fill:before {
  content: "\\e923";
}

.icon-flag-fill:before {
  content: "\\e924";
}

.icon-video-fill:before {
  content: "\\e925";
}

.icon-Solid:before {
  content: "\\e926";
}

.icon-book-mark-fill:before {
  content: "\\e927";
}

.icon-arrow-up-s-fill:before {
  content: "\\e928";
}

.icon-arrow-down-s-fill:before {
  content: "\\e929";
}

.icon-close-circle-line:before {
  content: "\\e92a";
}

.icon-coupon-3-line:before {
  content: "\\e92b";
}

.icon-arrow-right-s-line:before {
  content: "\\e92c";
}

.icon-zoom-in-line:before {
  content: "\\e92d";
}

.icon-checkbox-circle-line:before {
  content: "\\e92e";
}

.icon-menu-2-line:before {
  content: "\\e92f";
}

.icon-Settings:before {
  content: "\\e930";
}

.icon-Lock:before {
  content: "\\e931";
}

.icon-Browser:before {
  content: "\\e932";
}

.icon-Destination:before {
  content: "\\e933";
}

.icon-subtract-line:before {
  content: "\\e934";
}

.icon-add-line:before {
  content: "\\e935";
}

.icon-presentation:before {
  content: "\\e936";
}

.icon-Fitness:before {
  content: "\\e937";
}

.icon-Pencil:before {
  content: "\\e938";
}

.icon-Mind:before {
  content: "\\e939";
}

.icon-Open-book:before {
  content: "\\e93a";
}

.icon-arrow-right-line-right:before {
  content: "\\e93b";
}

.icon-arrow-left-line:before {
  content: "\\e93c";
}

.icon-Setting:before {
  content: "\\e93d";
}

.icon-Microscope:before {
  content: "\\e93e";
}

.icon-student-read:before {
  content: "\\e93f";
}

.icon-trophy:before {
  content: "\\e940";
}

.icon-mail-open-line:before {
  content: "\\e941";
}

.icon-account-circle-line:before {
  content: "\\e942";
}

.icon-Schoolbag:before {
  content: "\\e943";
}

.icon-Class:before {
  content: "\\e944";
}

.icon-Headphone:before {
  content: "\\e945";
}

.icon-file-list-4-line:before {
  content: "\\e946";
}

.icon-phone-line:before {
  content: "\\e947";
}

.icon-price-tag-3-line:before {
  content: "\\e948";
}

.icon-Laugh:before {
  content: "\\e949";
}

.icon-Support:before {
  content: "\\e94a";
}

.icon-Play:before {
  content: "\\e94b";
}

.icon-map-pin-line:before {
  content: "\\e94c";
}

.icon-Bag:before {
  content: "\\e94d";
}

.icon-Board:before {
  content: "\\e94e";
}

.icon-ribbon:before {
  content: "\\e94f";
}

.icon-Smile:before {
  content: "\\e950";
}

.icon-scale:before {
  content: "\\e951";
}

.icon-book-3-line:before {
  content: "\\e952";
}

.icon-science:before {
  content: "\\e953";
}

.icon-calculator:before {
  content: "\\e954";
}

.icon-compass:before {
  content: "\\e955";
}

.icon-pen-tool:before {
  content: "\\e956";
}

.icon-lab:before {
  content: "\\e957";
}

.icon-microscopes:before {
  content: "\\e958";
}

.icon-reading-book:before {
  content: "\\e959";
}

.icon-Heart:before {
  content: "\\e95a";
}

.icon-send-plane-fill:before {
  content: "\\e95b";
}

.icon-calendar-2-line:before {
  content: "\\e95c";
}

.icon-Star:before {
  content: "\\e95d";
  color: #ffa41b;
}

.off.icon-Star:before {
  content: "\\e95d";
  color: #2d284e;
  opacity: 0.15;
}

.icon-phone-fill:before {
  content: "\\e95e";
}

.icon-file-list-2-line:before {
  content: "\\e95f";
}

.icon-group-line:before {
  content: "\\e960";
}

.icon-user-line:before {
  content: "\\e961";
}

.icon-live-fill:before {
  content: "\\e962";
}

.icon-search-line:before {
  content: "\\e963";
}

.icon-mic-off-fill:before {
  content: "\\e964";
}

.icon-camera-fill:before {
  content: "\\e965";
}

.icon-arrow-right-line:before {
  content: "\\e966";
}

.icon-time-line:before {
  content: "\\e967";
}

.icon-file-list-3-line:before {
  content: "\\e968";
}

.icon-arrow-down-s-line:before {
  content: "\\e969";
}

.icon-Badge-icon:before {
  content: "\\e96a";
}

.icon-Campus:before {
  content: "\\e96b";
}

.icon-Hand---Book:before {
  content: "\\e96c";
}

.icon-square:before {
  content: "\\e96d";
}

.icon-clock:before {
  content: "\\e96e";
}

.icon-student:before {
  content: "\\e96f";
}

.icon-research:before {
  content: "\\e970";
}`, "",{"version":3,"sources":["webpack://./src/assets/css/eduvibe-font.css"],"names":[],"mappings":"AAAA;EACC,sBAAA;EACA,4CAAA;EACA,mPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAFD;AAIA;;EAEC,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;AAFD;;AAIA;EACC,gBAAA;AADD;;AAGA;EACC,gBAAA;AAAD;;AAEA;EACC,gBAAA;AACD;;AACA;EACC,gBAAA;AAED;;AAAA;EACC,gBAAA;AAGD;;AADA;EACC,gBAAA;AAID;;AAFA;EACC,gBAAA;AAKD;;AAHA;EACC,gBAAA;AAMD;;AAJA;EACC,gBAAA;AAOD;;AALA;EACC,gBAAA;AAQD;;AANA;EACC,gBAAA;AASD;;AAPA;EACC,gBAAA;AAUD;;AARA;EACC,gBAAA;AAWD;;AATA;EACC,gBAAA;AAYD;;AAVA;EACC,gBAAA;AAaD;;AAXA;EACC,gBAAA;AAcD;;AAZA;EACC,gBAAA;AAeD;;AAbA;EACC,gBAAA;AAgBD;;AAdA;EACC,gBAAA;AAiBD;;AAfA;EACC,gBAAA;AAkBD;;AAhBA;EACC,gBAAA;AAmBD;;AAjBA;EACC,gBAAA;AAoBD;;AAlBA;EACC,gBAAA;AAqBD;;AAnBA;EACC,gBAAA;AAsBD;;AApBA;EACC,gBAAA;AAuBD;;AArBA;EACC,gBAAA;AAwBD;;AAtBA;EACC,gBAAA;AAyBD;;AAvBA;EACC,gBAAA;AA0BD;;AAxBA;EACC,gBAAA;AA2BD;;AAzBA;EACC,gBAAA;AA4BD;;AA1BA;EACC,gBAAA;AA6BD;;AA3BA;EACC,gBAAA;AA8BD;;AA5BA;EACC,gBAAA;AA+BD;;AA7BA;EACC,gBAAA;AAgCD;;AA9BA;EACC,gBAAA;AAiCD;;AA/BA;EACC,gBAAA;AAkCD;;AAhCA;EACC,gBAAA;AAmCD;;AAjCA;EACC,gBAAA;AAoCD;;AAlCA;EACC,gBAAA;AAqCD;;AAnCA;EACC,gBAAA;AAsCD;;AApCA;EACC,gBAAA;AAuCD;;AArCA;EACC,gBAAA;AAwCD;;AAtCA;EACC,gBAAA;AAyCD;;AAvCA;EACC,gBAAA;AA0CD;;AAxCA;EACC,gBAAA;AA2CD;;AAzCA;EACC,gBAAA;AA4CD;;AA1CA;EACC,gBAAA;AA6CD;;AA3CA;EACC,gBAAA;AA8CD;;AA5CA;EACC,gBAAA;AA+CD;;AA7CA;EACC,gBAAA;AAgDD;;AA9CA;EACC,gBAAA;AAiDD;;AA/CA;EACC,gBAAA;AAkDD;;AAhDA;EACC,gBAAA;AAmDD;;AAjDA;EACC,gBAAA;AAoDD;;AAlDA;EACC,gBAAA;AAqDD;;AAnDA;EACC,gBAAA;AAsDD;;AApDA;EACC,gBAAA;AAuDD;;AArDA;EACC,gBAAA;AAwDD;;AAtDA;EACC,gBAAA;AAyDD;;AAvDA;EACC,gBAAA;AA0DD;;AAxDA;EACC,gBAAA;AA2DD;;AAzDA;EACC,gBAAA;AA4DD;;AA1DA;EACC,gBAAA;AA6DD;;AA3DA;EACC,gBAAA;AA8DD;;AA5DA;EACC,gBAAA;AA+DD;;AA7DA;EACC,gBAAA;AAgED;;AA9DA;EACC,gBAAA;AAiED;;AA/DA;EACC,gBAAA;AAkED;;AAhEA;EACC,gBAAA;AAmED;;AAjEA;EACC,gBAAA;AAoED;;AAlEA;EACC,gBAAA;AAqED;;AAnEA;EACC,gBAAA;AAsED;;AApEA;EACC,gBAAA;AAuED;;AArEA;EACC,gBAAA;AAwED;;AAtEA;EACC,gBAAA;AAyED;;AAvEA;EACC,gBAAA;AA0ED;;AAxEA;EACC,gBAAA;AA2ED;;AAzEA;EACC,gBAAA;AA4ED;;AA1EA;EACC,gBAAA;AA6ED;;AA3EA;EACC,gBAAA;AA8ED;;AA5EA;EACC,gBAAA;AA+ED;;AA7EA;EACC,gBAAA;AAgFD;;AA9EA;EACC,gBAAA;AAiFD;;AA/EA;EACC,gBAAA;AAkFD;;AAhFA;EACC,gBAAA;AAmFD;;AAjFA;EACC,gBAAA;AAoFD;;AAlFA;EACC,gBAAA;AAqFD;;AAnFA;EACC,gBAAA;AAsFD;;AApFA;EACC,gBAAA;AAuFD;;AArFA;EACC,gBAAA;AAwFD;;AAtFA;EACC,gBAAA;AAyFD;;AAvFA;EACC,gBAAA;AA0FD;;AAxFA;EACC,gBAAA;AA2FD;;AAzFA;EACC,gBAAA;EACA,cAAA;AA4FD;;AA1FA;EACC,gBAAA;EACA,cAAA;EACA,aAAA;AA6FD;;AA3FA;EACC,gBAAA;AA8FD;;AA5FA;EACC,gBAAA;AA+FD;;AA7FA;EACC,gBAAA;AAgGD;;AA9FA;EACC,gBAAA;AAiGD;;AA/FA;EACC,gBAAA;AAkGD;;AAhGA;EACC,gBAAA;AAmGD;;AAjGA;EACC,gBAAA;AAoGD;;AAlGA;EACC,gBAAA;AAqGD;;AAnGA;EACC,gBAAA;AAsGD;;AApGA;EACC,gBAAA;AAuGD;;AArGA;EACC,gBAAA;AAwGD;;AAtGA;EACC,gBAAA;AAyGD;;AAvGA;EACC,gBAAA;AA0GD;;AAxGA;EACC,gBAAA;AA2GD;;AAzGA;EACC,gBAAA;AA4GD;;AA1GA;EACC,gBAAA;AA6GD;;AA3GA;EACC,gBAAA;AA8GD;;AA5GA;EACC,gBAAA;AA+GD;;AA7GA;EACC,gBAAA;AAgHD","sourcesContent":["@font-face {\n\tfont-family: \"icomoon\";\n\tsrc: url(\"../fonts/icomoon.eot?3qm5q8\");\n\tsrc: url(\"../fonts/icomoon.eot?3qm5q8#iefix\") format(\"embedded-opentype\"),\n\t\turl(\"../fonts/icomoon.ttf?3qm5q8\") format(\"truetype\"),\n\t\turl(\"../fonts/icomoon.woff?3qm5q8\") format(\"woff\"),\n\t\turl(\"../fonts/icomoon.svg?3qm5q8#icomoon\") format(\"svg\");\n\tfont-weight: normal;\n\tfont-style: normal;\n\tfont-display: block;\n}\n[class^=\"icon-\"],\n[class*=\" icon-\"] {\n\tfont-family: \"icomoon\" !important;\n\tspeak: never;\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-variant: normal;\n\ttext-transform: none;\n\tline-height: 1;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n.icon-Double-arrow:before {\n\tcontent: \"\\e900\";\n}\n.icon-mail-line-2:before {\n\tcontent: \"\\e901\";\n}\n.icon-Fb:before {\n\tcontent: \"\\e902\";\n}\n.icon-linkedin:before {\n\tcontent: \"\\e903\";\n}\n.icon-Pinterest:before {\n\tcontent: \"\\e904\";\n}\n.icon-Twitter:before {\n\tcontent: \"\\e905\";\n}\n.icon-youtube:before {\n\tcontent: \"\\e906\";\n}\n.icon-award-line:before {\n\tcontent: \"\\e907\";\n}\n.icon-artboard-line:before {\n\tcontent: \"\\e908\";\n}\n.icon-translate:before {\n\tcontent: \"\\e909\";\n}\n.icon-bar-chart-2-line:before {\n\tcontent: \"\\e90a\";\n}\n.icon-Note-text-line:before {\n\tcontent: \"\\e90b\";\n}\n.icon-file-text-line:before {\n\tcontent: \"\\e90c\";\n}\n.icon-user-2:before {\n\tcontent: \"\\e90d\";\n}\n.icon-draft-line:before {\n\tcontent: \"\\e90e\";\n}\n.icon-arrow-up-s-line:before {\n\tcontent: \"\\e90f\";\n}\n.icon-lock-password-line:before {\n\tcontent: \"\\e910\";\n}\n.icon-share-fill:before {\n\tcontent: \"\\e911\";\n}\n.icon-reply-all-fill:before {\n\tcontent: \"\\e912\";\n}\n.icon-calendar-check-line:before {\n\tcontent: \"\\e913\";\n}\n.icon-user-fill-solid:before {\n\tcontent: \"\\e914\";\n}\n.icon-award-fill-solid:before {\n\tcontent: \"\\e915\";\n}\n.icon-discuss-line:before {\n\tcontent: \"\\e916\";\n}\n.icon-user-2-line_tie:before {\n\tcontent: \"\\e917\";\n}\n.icon-pentool:before {\n\tcontent: \"\\e918\";\n}\n.icon-book-mark-fill-solid:before {\n\tcontent: \"\\e919\";\n}\n.icon-arrow-right-s-line-right:before {\n\tcontent: \"\\e91a\";\n}\n.icon-book-line:before {\n\tcontent: \"\\e91b\";\n}\n.icon-shopping-basket-2-line:before {\n\tcontent: \"\\e91c\";\n}\n.icon-trophy-line:before {\n\tcontent: \"\\e91d\";\n}\n.icon-checkbox-circle-fill-solid:before {\n\tcontent: \"\\e91e\";\n}\n.icon-checkbox-circle-fill:before {\n\tcontent: \"\\e91f\";\n}\n.icon-eye-line:before {\n\tcontent: \"\\e920\";\n}\n.icon-call:before {\n\tcontent: \"\\e921\";\n}\n.icon-user-fill:before {\n\tcontent: \"\\e922\";\n}\n.icon-award-fill:before {\n\tcontent: \"\\e923\";\n}\n.icon-flag-fill:before {\n\tcontent: \"\\e924\";\n}\n.icon-video-fill:before {\n\tcontent: \"\\e925\";\n}\n.icon-Solid:before {\n\tcontent: \"\\e926\";\n}\n.icon-book-mark-fill:before {\n\tcontent: \"\\e927\";\n}\n.icon-arrow-up-s-fill:before {\n\tcontent: \"\\e928\";\n}\n.icon-arrow-down-s-fill:before {\n\tcontent: \"\\e929\";\n}\n.icon-close-circle-line:before {\n\tcontent: \"\\e92a\";\n}\n.icon-coupon-3-line:before {\n\tcontent: \"\\e92b\";\n}\n.icon-arrow-right-s-line:before {\n\tcontent: \"\\e92c\";\n}\n.icon-zoom-in-line:before {\n\tcontent: \"\\e92d\";\n}\n.icon-checkbox-circle-line:before {\n\tcontent: \"\\e92e\";\n}\n.icon-menu-2-line:before {\n\tcontent: \"\\e92f\";\n}\n.icon-Settings:before {\n\tcontent: \"\\e930\";\n}\n.icon-Lock:before {\n\tcontent: \"\\e931\";\n}\n.icon-Browser:before {\n\tcontent: \"\\e932\";\n}\n.icon-Destination:before {\n\tcontent: \"\\e933\";\n}\n.icon-subtract-line:before {\n\tcontent: \"\\e934\";\n}\n.icon-add-line:before {\n\tcontent: \"\\e935\";\n}\n.icon-presentation:before {\n\tcontent: \"\\e936\";\n}\n.icon-Fitness:before {\n\tcontent: \"\\e937\";\n}\n.icon-Pencil:before {\n\tcontent: \"\\e938\";\n}\n.icon-Mind:before {\n\tcontent: \"\\e939\";\n}\n.icon-Open-book:before {\n\tcontent: \"\\e93a\";\n}\n.icon-arrow-right-line-right:before {\n\tcontent: \"\\e93b\";\n}\n.icon-arrow-left-line:before {\n\tcontent: \"\\e93c\";\n}\n.icon-Setting:before {\n\tcontent: \"\\e93d\";\n}\n.icon-Microscope:before {\n\tcontent: \"\\e93e\";\n}\n.icon-student-read:before {\n\tcontent: \"\\e93f\";\n}\n.icon-trophy:before {\n\tcontent: \"\\e940\";\n}\n.icon-mail-open-line:before {\n\tcontent: \"\\e941\";\n}\n.icon-account-circle-line:before {\n\tcontent: \"\\e942\";\n}\n.icon-Schoolbag:before {\n\tcontent: \"\\e943\";\n}\n.icon-Class:before {\n\tcontent: \"\\e944\";\n}\n.icon-Headphone:before {\n\tcontent: \"\\e945\";\n}\n.icon-file-list-4-line:before {\n\tcontent: \"\\e946\";\n}\n.icon-phone-line:before {\n\tcontent: \"\\e947\";\n}\n.icon-price-tag-3-line:before {\n\tcontent: \"\\e948\";\n}\n.icon-Laugh:before {\n\tcontent: \"\\e949\";\n}\n.icon-Support:before {\n\tcontent: \"\\e94a\";\n}\n.icon-Play:before {\n\tcontent: \"\\e94b\";\n}\n.icon-map-pin-line:before {\n\tcontent: \"\\e94c\";\n}\n.icon-Bag:before {\n\tcontent: \"\\e94d\";\n}\n.icon-Board:before {\n\tcontent: \"\\e94e\";\n}\n.icon-ribbon:before {\n\tcontent: \"\\e94f\";\n}\n.icon-Smile:before {\n\tcontent: \"\\e950\";\n}\n.icon-scale:before {\n\tcontent: \"\\e951\";\n}\n.icon-book-3-line:before {\n\tcontent: \"\\e952\";\n}\n.icon-science:before {\n\tcontent: \"\\e953\";\n}\n.icon-calculator:before {\n\tcontent: \"\\e954\";\n}\n.icon-compass:before {\n\tcontent: \"\\e955\";\n}\n.icon-pen-tool:before {\n\tcontent: \"\\e956\";\n}\n.icon-lab:before {\n\tcontent: \"\\e957\";\n}\n.icon-microscopes:before {\n\tcontent: \"\\e958\";\n}\n.icon-reading-book:before {\n\tcontent: \"\\e959\";\n}\n.icon-Heart:before {\n\tcontent: \"\\e95a\";\n}\n.icon-send-plane-fill:before {\n\tcontent: \"\\e95b\";\n}\n.icon-calendar-2-line:before {\n\tcontent: \"\\e95c\";\n}\n.icon-Star:before {\n\tcontent: \"\\e95d\";\n\tcolor: #ffa41b;\n}\n.off.icon-Star:before {\n\tcontent: \"\\e95d\";\n\tcolor: #2d284e;\n\topacity: 0.15;\n}\n.icon-phone-fill:before {\n\tcontent: \"\\e95e\";\n}\n.icon-file-list-2-line:before {\n\tcontent: \"\\e95f\";\n}\n.icon-group-line:before {\n\tcontent: \"\\e960\";\n}\n.icon-user-line:before {\n\tcontent: \"\\e961\";\n}\n.icon-live-fill:before {\n\tcontent: \"\\e962\";\n}\n.icon-search-line:before {\n\tcontent: \"\\e963\";\n}\n.icon-mic-off-fill:before {\n\tcontent: \"\\e964\";\n}\n.icon-camera-fill:before {\n\tcontent: \"\\e965\";\n}\n.icon-arrow-right-line:before {\n\tcontent: \"\\e966\";\n}\n.icon-time-line:before {\n\tcontent: \"\\e967\";\n}\n.icon-file-list-3-line:before {\n\tcontent: \"\\e968\";\n}\n.icon-arrow-down-s-line:before {\n\tcontent: \"\\e969\";\n}\n.icon-Badge-icon:before {\n\tcontent: \"\\e96a\";\n}\n.icon-Campus:before {\n\tcontent: \"\\e96b\";\n}\n.icon-Hand---Book:before {\n\tcontent: \"\\e96c\";\n}\n.icon-square:before {\n\tcontent: \"\\e96d\";\n}\n.icon-clock:before {\n\tcontent: \"\\e96e\";\n}\n.icon-student:before {\n\tcontent: \"\\e96f\";\n}\n.icon-research:before {\n\tcontent: \"\\e970\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
